export const IridiumIcon = ({ ...props }) => (
	<svg
		width="172.69447mm"
		height="109.36905mm"
		viewBox="0 0 172.69447 109.36905"
		version="1.1"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g transform="translate(-23.953053,-87.331917)">
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="33.025982"
				cy="100.23153"
				r="9.0729294"
			/>
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="70.305283"
				cy="96.404846"
				r="9.0729294"
			/>
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="97.092064"
				cy="122.08066"
				r="9.0729294"
			/>
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="131.28532"
				cy="141.70784"
				r="9.0729294"
			/>
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="131.28532"
				cy="174.29637"
				r="9.0729294"
			/>
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="169.0584"
				cy="187.62804"
				r="9.0729294"
			/>
			<circle
				style="fill:#fcb034;fill-opacity:1;stroke-width:1.22695;stroke-linecap:round;stroke-linejoin:round;paint-order:markers fill stroke"
				cx="187.5746"
				cy="156.27393"
				r="9.0729294"
			/>
		</g>
	</svg>
)
